import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

const Button = styled.div`
	z-index: 99;
	margin-left: 5px;
	cursor: pointer;
`;

const Path = (props) => (
	<motion.path
		fill="transparent"
		strokeLinecap="round"
		strokeWidth="3"
		{...props}
	/>
);

const transition = { duration: 0.33 };

const MenuToggle = ({ toggle, isOpen }) => {
	return (
		<Button onClick={toggle}>
			<svg width="23" height="23" viewBox="0 0 23 23">
				<Path
					animate={isOpen ? "open" : "closed"}
					initial={false}
					stroke="rgba(10, 65, 93, 1)"
					variants={{
						closed: { d: "M 2 2.5 L 20 2.5",},
						open: { d: "M 3 16.5 L 17 2.5",},
						// closed: { d: "M 2 2.5 L 20 2.5", stroke: "hsl(0, 0%, 18%)" },
						// open: { d: "M 3 16.5 L 17 2.5", stroke: "hsl(0, 0%, 18%)" },
					}}
					transition={transition}
				/>
				<Path
					d="M 2 9.423 L 20 9.423"
					// stroke="rgba(255, 226, 93, 1)"
					stroke="rgba(10, 65, 93, 1)"
					animate={isOpen ? "open" : "closed"}
					initial={false}
					variants={{
						closed: { opacity: 1 },
						open: { opacity: 0 },
					}}
					transition={transition}
				/>
				<Path
					animate={isOpen ? "open" : "closed"}
					initial={false}
					stroke="rgba(10, 65, 93, 1)"
					variants={{
						closed: { d: "M 2 16.346 L 20 16.346",},
						open: { d: "M 3 2.5 L 17 16.346", },
					}}
					transition={transition}
				/>
			</svg>
		</Button>
	);
};

export default MenuToggle;